<template>
    <div v-if="show" class="left_menu">
      <div class="menulist">
          <!-- login true -->
        <template v-if="login">
          <div class="userInfo">
            <div class="flex_between">
              <div class="userName">
                  홍길동
              </div>
              <div class="settingBtn">
                <img src="@/assets/icon/icon_setting.png"/>
              </div>
            </div>
            <div @click="logout" class="logout">
              로그아웃<img src="@/assets/icon/arrow.png" />
            </div>
          </div>
        </template>
        <template v-else>
              <div class="userlogoutView">
                <div>
                  <div class="tiptitle">
                    아직 회원이 아니신가요?
                  </div>
                  <div class="tipcontent">
                    회원가입 후 더욱 다양한 혜택을 받으세요! <br/>
                    영상으로 본 상품 할인 쿠폰을 받으실 수<br/>
                    있는 절호의 찬스!
                  </div>
                  <div class="login_signup flex_center">
                    <div @click="loginPage" class="login_btn flex_center">
                      로그인
                    </div>
                    <div @click="signupPage" class="signup_btn flex_center">
                      회원가입
                    </div>
                  </div>
                </div>
              </div>
        </template>

        <template v-for="item in menuInfoComputed">
            <div class="menuinfo">
              <template v-for="info in item.list">
                <template v-if="info.display">
                  <div @click="menuLink(info)" class="flex_between">
                    <div class="text" v-text="info.name"></div>
                    <div class="desc" v-text="info.desc"></div>
                  </div>
                </template>
              </template>
            </div>
        </template>

        <div class="left_menu_logo_view">
          <div class="left_menu_logo flex_center">
            <img src="@/assets/icon/logo_6.png" />
          </div>
        </div>
      </div>

      <div @click="close" class="left_menu_close">
        <img src="@/assets/icon/icon_close_w.png"/>
      </div>
    </div>
</template>

<script>
	export default {
		name: "leftMenu"
    ,props:{
		  login:{
		    type:Boolean,
        default:false
      }
      ,userName:{
		    type:String,
        default:''
      }
      ,show:{
		    type:Boolean
        ,default:false
      }
    }
    ,data(){
		  return {
        menuinfo:[
          {
            login:true,
            list:[
              {
                name:'정보수정',
                desc:'MY',
                login:true,
                display:true,
                url:''
              },
              {
                name:'비밀번호 변경',
                desc:'',
                login:true,
                display:true,
                url:''
              },
              {
                name:'내 문의내역',
                desc:'',
                login:true,
                display:true,
                url:''
              },
              {
                name:'좋아요',
                desc:'',
                login:true,
                display:true,
                url:''
              }
            ]
          },
          {
            login:false
            ,list:[
              {
                name:'홈',
                desc:'바로가기',
                login:false,
                display:true,
                url:''
              },
              {
                name:'동영상',
                desc:'',
                login:false,
                display:true,
                url:''
              },
              {
                name:'LIVE',
                desc:'',
                login:false,
                display:true,
                url:''
              },
            ]
          }
          ,{
            login:false
            ,list:[
              {
                name:'FAQ',
                desc:'고객센터',
                login:false,
                display:true,
                url:''
              },
              {
                name:'공지사항',
                desc:'',
                login:false,
                display:true,
                url:''
              },
              {
                name:'회원문의',
                desc:'',
                login:true,
                display:true,
                url:''
              }

            ]
          }
        ]
      }
    }
    ,computed:{
		  menuInfoComputed(){
		    let list = [];
		    let info = {};
		    for(let index in this.menuinfo){
          let item = this.menuinfo[index];
          if(!this.login){
            if(!item.login){
              for(let index in item.list){
                let menulist = item.list[index];
                if(menulist.login){
                  menulist.display = false;
                }
              }
              info = item;
            }else{
              continue;
            }
          }else{
            info = item;
          }
          list.push(info);
        }
        return list;
      }
    }
    ,methods:{
      logout(){

      }
      ,loginPage(){
        this.$router.push({name:'login'});
      }
      ,signupPage(){
        this.$router.push({name:'signup'});
      }
      ,menuLink(info){
        console.log(info);
      }
      ,close(){
        this.$parent.leftMenuShow = false;
      }

    }
	}
</script>

<style scoped>
  .left_menu {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color:rgba(0,0,0,.3);
    z-index: 99;
  }
  .menulist {
    overflow: hidden;
    width: 6.972rem;
    height: 100%;
    background-color: #fff;
    border-right: 0.014rem solid #707070c2;

  }
  .userInfo{
    padding: 0.833rem 0 1.389rem 0;
    margin: 0 0.833rem;
    border-bottom: 1px solid #E3E3E3;
  }
  .userName {
    font-size: 0.472rem;
  }
  .userName:after {
    content:'님';
    font-size: 0.389rem;
    color: #9F9F9F;

  }

  .settingBtn {
    width: 0.571rem;
    height: 0.571rem;
  }
  .settingBtn img {
    height:100%;
    width: 100%;
  }
  .logout {
    font-size: 0.389rem;
    padding: 0.278rem 0 0 0;
    color: #9F9F9F;
    display: flex;
    align-items: center;
    width: 2.083rem;
  }
  .logout > img {
    width: 0.417rem;
    height: 0.278rem;
    padding: 0 0 0  0.139rem;
  }

  .menuinfo {
    padding: 0.556rem 0 0.556rem 0;
    margin: 0 0.833rem;
    border-bottom: 1px solid #E3E3E3;
  }
  .menuinfo:nth-last-child(2){
    border-bottom: none;
  }
  .menuinfo > div {
    margin: 0 0 0.556rem 0;
  }
  .menuinfo > div:last-child{
    margin: 0;
  }

  .menuinfo .text {
    font-size: 0.389rem;
  }
  .menuinfo .desc {
    font-size: 0.333rem;
    color:#E3E3E3;
  }
  .left_menu_logo_view {
    height: 1.083rem;
  }
  .left_menu_logo{
    position: fixed;
    width: 100%;
    bottom: 0.556rem;
    left: 0;
    max-width: 6.972rem;
  }
  .left_menu_logo img{
    width: 1.653rem;
    height: 0.526rem;
  }

  .userlogoutView {
    padding: 0.833rem 0.278rem;
  }
  .userlogoutView > div {
    padding: 0.556rem;
    background-color: #F8F7F4;
    -webkit-border-radius: 0.139rem;
    -moz-border-radius: 0.139rem;
    border-radius: 0.139rem;
  }

  .tiptitle {
    color: #F15929;
    font-size: 0.417rem;
  }
  .tipcontent {
    padding: 0.208rem 0 0 0;
    color: #9F9F9F;
    font-size: 0.306rem;
    line-height: 0.444rem;
  }
  .login_signup {
    padding: 0.833rem 0 0 0;
  }

  .login_btn {
    width: 50%;
    border-right: 0.014rem solid #C8C8C8;
  }

  .signup_btn {
    width: 50%;
  }

  .left_menu_close {
    position: fixed;
    top: 0.833rem;
    left: 7.528rem;
    width: 0.639rem;
    height: 0.639rem;
  }

  .left_menu_close img {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/leftMenu.vue